import React from 'react';
import { arrayforMulti } from './utils';
import MultiSelect from './MultiSelect';

const SelectResource = ({ users, onChange, selectedItems }) => {
    const allItems = arrayforMulti(users);

    return (
        <MultiSelect
            allItems={allItems}
            onChange={onChange}
            selectedItems={selectedItems}
            title="Resources"
        />
    );
};

export default SelectResource;
